import React from 'react';
import { Tag, Eye, EyeOff } from 'lucide-react';

interface TagData {
  tagCategory: string;
  associatedTerms: string[];
}

interface TagsDisplayProps {
  tags: TagData[];
  title?: string;
}

const TagsDisplay: React.FC<TagsDisplayProps> = ({ tags, title = "Generated Tags" }) => {
  const [showDetails, setShowDetails] = React.useState(false);

  if (!tags || tags.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="text-center">
          <Tag className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">No tags generated</h3>
          <p className="text-gray-600">No semantic tags were found for this phrase.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Tag className="h-5 w-5 mr-2" />
            {title} ({tags.length} categories)
          </h3>
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="flex items-center space-x-1 text-blue-600 text-sm font-medium hover:text-blue-700"
          >
            {showDetails ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            <span>{showDetails ? 'Hide' : 'Show'} details</span>
          </button>
        </div>
      </div>
      
      <div className="p-6">
        {showDetails ? (
          <div className="space-y-4">
            {tags.map((tag, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-3 capitalize">
                  {tag.tagCategory}
                </h4>
                <div className="flex flex-wrap gap-2">
                  {tag.associatedTerms.map((term, termIndex) => (
                    <span
                      key={termIndex}
                      className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full"
                    >
                      {term}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-wrap gap-2">
            {tags.map((tag, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full capitalize"
              >
                {tag.tagCategory} ({tag.associatedTerms.length})
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TagsDisplay; 